<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><b>Contents</b></p>
<p class="contents-ct" id="shello"><a href="#/007Hello_Again#hello">Hello Again!</a></p>
<p class="contents-ct" id="sct1"><a href="#/008Chapter_1#ct1"><span class="conblock">Chapter 1 </span><b>The Crash</b></a></p>
<p class="contents-ct" id="sct2"><a href="#/009Chapter_2#ct2"><span class="conblock">Chapter 2 </span><b>Adrenaline – My Frenemy</b></a></p>
<p class="contents-ct" id="sct3"><a href="#/010Chapter_3#ct3"><span class="conblock">Chapter 3 </span><b>Poised</b></a></p>
<p class="contents-ct" id="sct4"><a href="#/011Chapter_4#ct4"><span class="conblock">Chapter 4 </span><b>Adapting</b></a></p>
<p class="contents-ct" id="sct5"><a href="#/012Chapter_5#ct5"><span class="conblock">Chapter 5 </span><b>Who Cares About Care?</b> </a></p>
<p class="contents-ct" id="sct6"><a href="#/013Chapter_6#ct6"><span class="conblock">Chapter 6 </span><b>Sharking It</b></a></p>
<p class="contents-ct" id="sct7"><a href="#/014Chapter_7#ct7"><span class="conblock">Chapter 7 </span><b>A Leap of Faith</b></a></p>
<p class="contents-ct" id="sct8"><a href="#/015Chapter_8#ct8"><span class="conblock">Chapter 8 </span><b>Reaching for the Strawberry</b></a></p>
<p class="contents-ct" id="sct9"><a href="#/016Chapter_9#ct9"><span class="conblock">Chapter 9 </span><b>The Dark Side</b></a></p>
<p class="contents-ct" id="sct10"><a href="#/017Chapter_10#ct10"><span class="conblock">Chapter 10 </span><b>Am I Grieving?</b> </a></p>
<p class="contents-ct" id="sct11"><a href="#/018Chapter_11#ct11"><span class="conblock">Chapter 11 </span><b>Letting Go</b></a></p>
<p class="contents-ct" id="sct12"><a href="#/019Chapter_12#ct12"><span class="conblock">Chapter 12 </span><b>Work in Progress</b></a></p>
<p class="contents-ct" id="sack"><a href="#/020Acknowledgements#ack">Acknowledgements</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-Contents.vue?a5bd1be8